import React from "react";

import AuditHistoryData from "./AuditHistoryData";
import InfoText from "../Info/InfoText";
import Avatar from "../Common/Avatar";
import Divider from "../Common/Divider";
import { dateFormator, getClientId, getEmployeeId } from "../../utils";
import Button from "../Buttons/Button";
import { exactUTCDate } from "../../utils/dateFormator";
import { getShortBusinessName } from "../../pages/InnerPages/Employee/EmployeeProfile/Timesheets/TimesheetDetails";
import { TimesheetStatus } from "../../assets/data/enumData";
import StatusTags from "../Tags/StatusTags";

const AuditHistory = ({ data, placementData, approverWithStatus }) => {

  return (
    <div>
      {/* <div className="grid grid-cols-4 bg-black p-4 mb-10 absolute -mt-[61px]  left-1 right-1 -z-0 rounded-t-md"> */}
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-4 bg-black p-4">
        <div className="text-primary">Timesheet Audit History</div>
        <div>
          <InfoText
            title={"Employee Name / ID"}
            value={`${data?.employeeId?.firstName} | ${getEmployeeId(
              data?.employeeId?.uiid,
              data?.employeeId?.employmentType
            )}`}
            color="white"
          />
        </div>
        <div>
          {" "}
          <InfoText
            title={"Timesheet Dates"}
            value={`${exactUTCDate(data?.period?.from)} to ${exactUTCDate(
              data?.period?.to
            )}`}
            color="white"
          />
        </div>
        <div>
          {" "}
          <InfoText
            title={"Placement"}
            value={`${
              placementData?.jobInfo?.jobTitle
            } | ${getShortBusinessName(
              placementData?.jobInfo?.billClient?.businessName
            )}-${placementData?.uiid}`}
            color="white"
          />
        </div>
      </div>

      <div className="flex flex-col gap-10 pt-10">
        {approverWithStatus.map((data, index) => {
          const statusLabel = TimesheetStatus?.find(
            (status) => status.label === data.status
          )?.label;
          const statusColors = {
            Draft: "text-warning",
            Submitted: "text-info",
            Approved: "text-success",
            Rejected: "text-danger",
            "Job Inactive": "text-secondary",
            Invoiced: "text-primary",
          };
          const textColor = statusColors[statusLabel] || "text-black";
          return (
            <div key={index} className="flex gap-16 p-2">
              {/* <Divider orientation="vertical" /> */}
              <div className="flex gap-3 items-center justify-end">
                <Avatar size="3xl" alt={data.name} />
                <div className="flex flex-col gap-2 justify-end text-end w-36">
                  <div className="body-two font-medium leading-none">
                    {data.name}
                  </div>
                    <StatusTags tag={data?.status} variant="text" icon size="sm" className="justify-end" />
                </div>
              </div>
              <div className="flex-1 flex justify-between border-2 rounded-md p-2">
                <div className="flex flex-col justify-between gap-1">
                  {/* <InfoText
                    oneLine
                    title={"Comment:"}
                    value={data.comment}
                    className="text-sm"
                  /> */}
                  <InfoText
                    oneLine
                    title={"Attachemnts:"}
                    value={
                      <Button
                        title={"asdf"}
                        variant="text"
                        color="black"
                        className="!p-0.5"
                        icon="download"
                        iconPosition="after"
                        onClick={() => {}}
                      />
                    }
                    className="text-sm"
                  />
                </div>
                <div className="flex items-center  gap-5">
                  <InfoText
                    title={"Total Time"}
                    size={{
                      valueSize: "xl",
                    }}
                    value={data?.details?.st || 0}
                    color="info"
                  />
                  <Divider orientation="vertical" />
                  <InfoText
                    title={"Billable Hours"}
                    size={{
                      valueSize: "xl",
                    }}
                    value={data?.details?.st || 0}
                    color="success"
                  />
                  <Divider orientation="vertical" />
                  <InfoText
                    title={"Standard Time"}
                    size={{
                      valueSize: "xl",
                    }}
                    value={data?.details?.st || 0}
                    color="primary"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AuditHistory;
